import Route from '@ember/routing/route';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenPulseModel = Resolved<
  ReturnType<AppServicesWaldenPulseRoute['model']>
>;

export default class AppServicesWaldenPulseRoute extends Route {
  model() {
    return { stats: [] };
  }
}
